import { render } from "./Tasks.vue?vue&type=template&id=7e146de1"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/lockstep/Tasks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e146de1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e146de1', __exports__)) {
    api.reload('7e146de1', __exports__)
  }
  
  module.hot.accept("./Tasks.vue?vue&type=template&id=7e146de1", () => {
    api.rerender('7e146de1', render)
  })

}


export default __exports__